import { IGuide } from 'common/interfaces';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { useRef } from 'react';
import { useDispatch } from 'react-redux';

import useGuideDragAndDrop from './useGuideDragAndDrop';
import useGuideSelection from './useGuideSelection';

interface IUseGuide {
  elemRef: React.RefObject<HTMLDivElement>;
  isSelected: boolean;
}

export default function useGuide(guideData: IGuide): IUseGuide {
  const dispatch = useDispatch();

  const elemRef = useRef<HTMLDivElement>(null);

  const pressedKeys = useTypedSelector((state) => state.common.pressedKeys);
  const selectedGuidesIds = useTypedSelector(
    (state) => state.guides.selectedGuidesIds,
  );

  useGuideDragAndDrop(
    guideData,
    selectedGuidesIds,
    elemRef,
    pressedKeys,
    dispatch,
  );

  const { isSelected } = useGuideSelection(
    guideData,
    selectedGuidesIds,
    elemRef,
    pressedKeys,
    dispatch,
  );

  return {
    elemRef,
    isSelected,
  };
}
